import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import Loading from "../../../core/common/custom-loading/Loading";
import SearchSelect from "../../../core/common/search-select/searchSelect";
import CommonSelect2 from "../../../core/common/commonSelect2";

const StaffList = () => {
  const [loading, setLoading] = useState(false);
  const routes = all_routes;
  const [selectedItemId, setSelectedItemId] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState<any>(false);
  const [ViewAdminData, setViewAdminData] = useState<any>([]);
  const [viewStaffRoles, setViewStaffRoles] = useState<any[]>([]);
  const [roleIds, setRoleIds] = useState<number[]>([]);
  const [orgStaff, setOrgStaff] = useState<any>([]);
  const organizationId = localStorage.getItem("organization_id");

  const getAllProperty = async () => {
    const payload = {
      organization_id: organizationId,
      category_code: "ADMINSTAFF",
      dashboard: "true",
    };
    try {
      setLoading(true);
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.GET_ORG_ADMINSTAFF,
        payload,
      );
      // console.log("property data vvvvvvvv", response?.data)
      if (response?.success) {
        const result = response?.data;
        setOrgStaff(result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllProperty();
  }, []);
  const viewAllAdminData = async (staffId: any) => {
    const payload = {
      staffId: staffId,
    };
    setLoading(true);
    try {
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.VIEW_ALL_ADMIN,
        payload,
      );
      // console.log("arjun,m,,,,,,,,,,,,,,,", response)
      if (response?.success) {
        // setViewAdminData(response?.data[0])
        setViewAdminData({
          ...response?.data[0],
          properties: response?.data[0].properties || [],
          subtypes: response?.data[0].subtypes || [],
        });
        setIsModalOpen(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getViewStaffRoles();
  }, []);

  const getViewStaffRoles = async () => {
    setLoading(true);
    try {
      const response = await AXIOSCONFIGMETHOD(
        "get",
        webServiceUrl.VIEW_STAFF_ROLES,
      );
      if (response?.success && Array.isArray(response?.data)) {
        setViewStaffRoles(response.data);
        const ids = response.data.map((role: any) => role.role_id);
        setRoleIds(ids);
      } else {
        console.warn("Unexpected data format:", response?.data);
      }
    } catch (error) {
      console.error("Failed to fetch staff roles:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Staff ID",
      dataIndex: "staff_id",
      render: (text: string, record: any) => (
        <p className="text-capitalize">{text ?? "-"}</p>
      ),
      sorter: (a: any, b: any) =>
        (a.staff_id || "").localeCompare(b.staff_id || ""),
    },
    {
      title: "Service  Name",
      dataIndex: "service_name",
      render: (text: string, record: any) => (
        <p className="text-capitalize">{text ?? "-"}</p>
      ),
      sorter: (a: any, b: any) =>
        (a.service_name || "").localeCompare(b.service_name || ""),
    },

    {
      title: "Full Name",
      dataIndex: "full_name",
      render: (text: string, record: any) => (
        <p className="text-capitalize">{text ?? "-"}</p>
      ),
      sorter: (a: any, b: any) =>
        (a.full_name || "").localeCompare(b.full_name || ""),
    },

    {
      title: "Category Name",
      dataIndex: "category_name",
      render: (text: string, record: any) => (
        <p className="text-capitalize">{text ?? "-"}</p>
      ),
      sorter: (a: any, b: any) =>
        (a.category_name || "").localeCompare(b.category_name || ""),
    },
    {
      title: "Contact",
      dataIndex: "contact_number",
      render: (text: string, record: any) => (
        <p className="text-capitalize">{text ?? "-"}</p>
      ),
      sorter: (a: any, b: any) =>
        (a.contact_number || "").localeCompare(b.contact_number || ""),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <div className="d-flex align-items-center">
          <i
            className="fas fa-eye"
            style={{ cursor: "pointer", paddingLeft: "15px" }}
            onClick={() => {
              viewAllAdminData(record.staff_id);
            }}
          ></i>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Admin</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Admin List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
              {/* <Link to={routes.AllOrganizations}>
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-arrow-left me-2" />
                                    Back
                                </button>
                            </Link> */}
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* <div className="col-md-12 mb-3 bg-white border p-3 shadow-sm rounded-3">
                        <label className='pb-2 fw-medium fs-15 d-block'>Select Organization:</label>
                        <CommonSelect2 className='d-inline ' options={options_organization} name='organization' defaultValue={orgId} onChange={(e: any) => setOrgId(e?.value)} styles={{ maxWidth: "500px" }} />
                        <button className='btn btn-primary px-3 ms-2' onClick={searchProperties}> <i className="bi bi-search me-sm-1"></i><span className='d-none d-sm-inline'>Search</span></button>
                    </div> */}

          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Admin List</h5>
            </div>
            <div className="card-body p-0">
              {loading ? (
                <Loading />
              ) : (
                <Table
                  dataSource={orgStaff}
                  rowKeyId={"Staff_id"}
                  columns={columns}
                  Selection={false}
                />
              )}
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} Nestfin Technology. All rights
            reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* modal start  */}

      {/* my new code modal start */}

      <div
        className="modal fade show custom-staff-modal"
        style={{ display: isModalOpen ? "block" : "none" }}
        tabIndex={-1}
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{ViewAdminData?.full_name}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setIsModalOpen(false)}
              ></button>
            </div>

            <div className="modal-body">
              {ViewAdminData ? (
                <>
                  {/* <div className="section-card mb-4">
                                        <h6 className="section-title">📝 Basic Information</h6>
                                        <div className="row">
                                            {[
                                                { label: "Full Name", value: ViewAdminData?.full_name },
                                                { label: "Gender", value: ViewAdminData?.gender },
                                                { label: "Contact", value: ViewAdminData?.contact_number },
                                                { label: "Category", value: ViewAdminData?.category_name },
                                                { label: "Service Name", value: ViewAdminData?.service_name },
                                                { label: "Staff ID", value: ViewAdminData?.staff_id },
                                                { label: "Organization ID", value: ViewAdminData?.organization_id },
                                                { label: "Category Code", value: ViewAdminData?.category_code },
                                                { label: "Staff Service ID", value: ViewAdminData?.staff_service_id },
                                            ].map((item, index) => (
                                                <div className="col-12 col-sm-6 col-md-4 mb-2" key={index}>
                                                    <div className="label-value">
                                                        <strong>{item.label}:</strong>
                                                        <div>{item.value ?? "-"}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div> */}

                  {/* 🏠 Assigned Properties */}
                  <div className="section-card mb-4">
                    <h6 className="section-title">Assigned Properties</h6>
                    <div className="assigned-table-container">
                      {Array.isArray(ViewAdminData?.properties) &&
                      ViewAdminData?.properties.length > 0 ? (
                        <table className="assigned-table">
                          <thead>
                            <tr>
                              <th>Property Name</th>
                              <th>Block No</th>
                              <th>Address</th>
                              <th>City</th>
                              <th>State</th>
                              <th>Pincode</th>
                              {/* <th>Property Id</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {ViewAdminData?.properties.map((prop: any) => (
                              <tr key={prop.property_id}>
                                <td>{prop.property_name ?? "-"}</td>
                                <td>{prop.house_flat_block_no ?? "-"}</td>
                                <td
                                  style={{ maxWidth: 250, textWrap: "wrap" }}
                                  className=""
                                >
                                  {prop.address ?? "-"}
                                </td>
                                <td>{prop.city ?? "-"}</td>
                                <td>{prop.state ?? "-"}</td>
                                <td>{prop.pincode ?? "-"}</td>
                                {/* <td>{prop.property_id ?? "-"}</td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <p className="text-center text-muted">
                          No assigned properties found.
                        </p>
                      )}
                    </div>
                  </div>

                  {/* ------------------- */}

                  <div className="section-card">
                    <h6 className="section-title">Sub Services</h6>

                    {ViewAdminData?.service_name === "Sales" ? (
                      <p className="text-center text-muted">
                        Sub services are not shown for Sales staff.
                      </p>
                    ) : ViewAdminData?.service_name === "Caretaker" ? (
                      <div className="compact-subservice-card">
                        {/* Header Row */}
                        <div className="compact-row compact-header">
                          <span className="role-name">Role</span>
                          <span className="permission-status">Permission</span>
                        </div>

                        {/* Dynamic Rows */}
                        {Array.isArray(ViewAdminData?.subtypes) &&
                        ViewAdminData.subtypes.length > 0 ? (
                          ViewAdminData.subtypes.map((sub: any, index: any) => {
                            const matchedRole = viewStaffRoles.find(
                              (role) => role.role_id === sub.role_id,
                            );
                            const formattedCode = matchedRole?.code
                              ?.toLowerCase()
                              ?.split("_")
                              ?.map(
                                (word: any) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              ?.join(" ");

                            return (
                              <div className="compact-row" key={index}>
                                <span className="role-name">
                                  {formattedCode ?? "Unknown Code"}
                                </span>
                                <span
                                  className={`permission-status ${
                                    sub.permission === "No"
                                      ? "denied"
                                      : "granted"
                                  }`}
                                >
                                  {sub.permission ?? "-"}
                                </span>
                              </div>
                            );
                          })
                        ) : (
                          <p className="text-muted">
                            No sub services assigned.
                          </p>
                        )}
                      </div>
                    ) : (
                      <div className="generic-subservices-wrapper">
                        {Array.isArray(ViewAdminData?.subtypes) &&
                        ViewAdminData?.subtypes.length > 0 ? (
                          ViewAdminData?.subtypes.map((sub: any) => (
                            <span
                              className="abb"
                              key={sub.staff_sub_service_id}
                            >
                              {sub.sub_service_name}
                            </span>
                          ))
                        ) : (
                          <p className="text-center text-muted">
                            No sub services assigned.
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  {/* ---------------------- */}
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setIsModalOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* my new code modal end */}

      {/* my old code this modal  */}

      {/* 



            {/* modal end  */}
    </>
  );
};

export default StaffList;
